import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import QuoteResultsSection from './QuoteResultsSection';
import QuoteForm from './QuoteForm';
import EstimateCard from './EstimateCard'
import CoverageLengths from '../../Helpers/Data/Products/Term/FullUWCoverageLengths';
import HealthClasses from '../../Helpers/Lists/HealthClasses';
import ErrorHandler from '../../Helpers/Errors/ErrorHandler';
import NoResultsFoundError from '../../Helpers/Errors/CustomErrors/NoResultsFoundError';

import "../../Quoters/Quoter.scss";

export default function BudgetBasedQuoter() {

  const [loading, setLoading] = useState(false);
  const coverageLengths = CoverageLengths();

  const product = {
    coverageLengths: coverageLengths,
    healthClasses: HealthClasses(),
    maxAge: 90,
    minAge: 18
  }

  const [birthdate, setBirthdate] = useState('1990-06-25');
  const [gender, setGender] = useState('F');
  const [tobacco, setTobacco] = useState('no');
  const [stateOfResidence, setStateOfResidence] = useState('ID');
  const [healthClass, setHealthClass] = useState('PP');
  const [budgetAmount, setBudgetAmount] = useState('28');
  const [termLength, setTermLength] = useState('20');

  const [quoteResults, setQuoteResults] = useState(null);

  const quoteFields = {
    birthdate: birthdate,
    setBirthdate: setBirthdate,
    stateOfResidence: stateOfResidence,
    setStateOfResidence: setStateOfResidence,
    gender: gender,
    setGender: setGender,
    tobacco: tobacco,
    setTobacco: setTobacco,
    termLength: termLength,
    setTermLength: setTermLength,
    budgetAmount: budgetAmount,
    setBudgetAmount: setBudgetAmount,
    healthClass: healthClass,
    setHealthClass: setHealthClass
  };

  useEffect(() => {
    getQuote();
  }, []);

  function getQuote() {
    setLoading(true);
    clearResults('Loading...');
    var quoteCards = [];

    fetch(`/api/LGA/GetCoverageByPremium?premium=${budgetAmount}&term=${termLength}&state=${stateOfResidence}&birthdate=${birthdate}&healthClass=${healthClass}&gender=${gender}&tobacco=${tobacco === 'yes'}`)
      .then(res => res.json())
      .then(data => {
        if (!data.carrierName) {
          throw new NoResultsFoundError();
        }

        quoteCards = [<EstimateCard key={0} id={0} quote={data} />];
        setQuoteResults(<QuoteResultsSection quotes={quoteCards} budgetAmount={budgetAmount} quotesTermOptions={quoteCards} />);
        setLoading(false);

      }).catch(error => { 
        ErrorHandler(error, setQuoteResults);
        setLoading(false);
      });
  }

  function clearResults(message) {
    const quoteCards = [<EstimateCard key="0" loading quote={{}} />]
    setQuoteResults(<QuoteResultsSection loading message={message} quotes={quoteCards} budgetAmount={budgetAmount} termLength={termLength} />)
  }

  return (
    <div>
      <Helmet>
        <title>Covr Consumer - Budget Basesd Quoter</title>
      </Helmet>

      <Container fluid className="policy-advisor">
        <Row className="background-image" style={{ backgroundImage: `url('/tools/GreenMountain.png')` }}>
          <Col>
            <h1>
              Budget Based Life<br />Insurance Quoter
            </h1>
          </Col>
        </Row>
        <br />

      </Container>
      <div className="quoter">
        <Container className="budget-based-quoter">
          <Row>
            <QuoteForm getQuote={getQuote} quoteFields={quoteFields} landingUrl="/landing/term" product={product} loading={loading} />
            {quoteResults}
          </Row>
        </Container>
      </div>
    </div>
  );
}




// WEBPACK FOOTER //
// ./src/components/Tools/BudgetBasedQuoter/BudgetBasedQuoter.js